import type { ReactTable } from '@tanstack/react-table';

import type { DataTableFeatures } from 'design-system';

import type { CatalogItem } from '@/entities/catalog-item';
import { additionalColumnsList, defaultColumnsList, moreColumnsList } from '../../../constants';

// Deliberately NOT design-system's `getHiddenColumnCount`: that counts every
// hideable leaf column across the whole table that's currently hidden,
// including the ~19 columns hidden by `defaultVisibilityState` that this
// panel doesn't even expose a toggle for. This badge means something
// different — how many of the *optional, user-toggleable* columns are
// currently switched ON — so it stays scoped to the three toggle-list groups.
const getActiveColumnCount = (table: ReactTable<DataTableFeatures, CatalogItem>) => {
  const visibilityById = new Map(
    table.getAllColumns().map(column => [column.id, column.getIsVisible()])
  );
  const allToggleableColumns = [
    ...defaultColumnsList,
    ...additionalColumnsList,
    ...moreColumnsList
  ];

  return allToggleableColumns.filter(({ accessorKey }) => visibilityById.get(accessorKey)).length;
};

export default getActiveColumnCount;
